import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { UserFriendsDetail } from './types';

export interface UserFriendsFilters {
  from?: string;
  to?: string;
}

export function useUserFriends(userId: string, filters: UserFriendsFilters) {
  const { request } = useAdminApi();
  const [data, setData] = useState<UserFriendsDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(
        await request<UserFriendsDetail>({
          env: 'prod',
          path: `/admin/analytics/friends/users/${userId}`,
          query: filters as Record<string, string | number | undefined>,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load user friends');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, userId, JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
